import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { Directive, forwardRef, OnInit } from '@angular/core';

import { ofMinorAge } from './validator';

@Directive({
    selector: '[ofMinorAge][formControlName],[ofMinorAge][formControl],[ofMinorAge][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => OfMinorAgeDirective),
            multi: true,
        },
    ],
})
export class OfMinorAgeDirective implements Validator, OnInit {
    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = ofMinorAge();
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
}
